import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ReactTable from "react-table";
import { toast } from "react-toastify";
import queryString from "query-string";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import axios from "../../axios-instance";

import Container from "../../components/UI/Container/Container";
import PageTitle from "../../components/UI/PageTitle/PageTitle";

import ROUTES from "../../constants/routes";
import Page404 from "../../components/Page404/Page404";

import Link from "react-router-dom/es/Link";

import {
  clearCurrentEvent,
  getEvent,
  getTicket,
} from "../../store/actions/eventsActions";

import "./TicketActions.sass";
import Upload from "../Upload/Upload";
import { getHeaders } from "../../helpers/getHeaders";
import {
  actionHandler,
  getActions,
} from "../../store/actions/ticketGenerationActions";
import NewLoader from "../../components/NewLoader/NewLoader";
import Icon from "../../components/UI/Icon/Icon";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { getCustomURLs } from "../../helpers/getCustomURLs";

const MySwal = withReactContent(Swal);

class GeneratePdfs extends Component {
  state = {
    file: [],
    generationTitle: "",
    isFound: true,
    isSubmitBlocked: false,
    loading: false,
  };

  componentDidMount() {
    const {
      user: { token },
      match: { params },
      getEvent,
      getTicket,
      getActions,
    } = this.props;

    if (params.event_id) {
      getTicket(params.id, token).then((result) => {
        if (!result.isFound) {
          this.setState({ isFound: false });
        }
      });
    }

    const action = queryString.parse(this.props.location.search).action;

    if (!this.props.currentEvent.id)
      getEvent(params.event_id, token, action).then((result) => {
        if (!result.isFound) {
          this.setState({ isFound: false });
        }
      });

    if (this.props.currentTicket.id || params.id) {
      getActions(token, this.props.currentTicket.id || params.id);
      this.intervalId = setInterval(
        () =>
          getActions(token, this.props.currentTicket.id || params.id, false),
        30000
      );
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  onButtonEnable = (file) => {
    if (!this.state.generationTitle) {
      console.log(file[0].name.split(".")[0]);
      this.setState({
        generationTitle: file[0].name.split(".")[0],
        file,
      });
      return;
    }

    this.setState({
      file,
    });
  };

  handleSubmit = async () => {
    //TODO: Should use redux!!!
    try {
      const {
        match: { params },
      } = this.props;
      this.setState({ loading: true });
      const user = JSON.parse(localStorage.getItem("user"));

      const { file, generationTitle } = this.state;

      const body = new FormData();
      body.append("file", file[0]);

      const { data } = await axios.post(
        `/TicketGeneration/AddTickets/${params.id}?generationTitle=${generationTitle}&needBookSeats=false`,
        body,
        {
          headers: getHeaders(user.token),
        }
      );

      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.state.generationTitle}_uplRes.csv`
        );
        document.body.appendChild(link);
        link.click();
      }
      this.setState({ loading: false, generationTitle: "" });
      this.props.getActions(
        user.token,
        this.props.currentTicket.id || params.id
      );
      toast.success("File uploaded successfully");
    } catch (e) {
      toast.error("Something went wrong. Try later");
      console.log(e);
    }
  };

  checkIsDisabled = () => {
    const { file, generationTitle, isSubmitBlocked } = this.state;

    if (isSubmitBlocked) return true;

    return !file || !file.length || !generationTitle;
  };

  actionHandler = (type, id) => {
    const {
      user: { token },
    } = this.props;

    this.props.actionHandler(token, id, type).then(() => {
      this.props.getActions(token, this.props.currentTicket.id);
    });
  };

  handleChange = (type, value) => {
    this.setState({
      [type]: value,
    });
  };

  loadResult = async (id, name) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await axios.get(
        `/TicketGeneration/LoadGenerationResult?generationActionId=${id}`,
        {
          headers: getHeaders(user.token),
          responseType: "arraybuffer",
        }
      );

      if (res.data) {
        const fileName = name ? name + ".zip" : "SponsorshipTickets.zip";
        const blob = new Blob([res.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }
    } catch (e) {
      toast.error("Something went wrong. Try later");
      console.log(e);
    }
  };

  showConfirmModal = ({
    title,
    text,
    confirmButtonText,
    cancelButtonText = "Cancel",
    reverseButtons = true,
    onConfirm,
  }) => {
    MySwal.fire({
      title: title,
      text: text,
      showCancelButton: true,
      cancelButtonText: cancelButtonText,
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      reverseButtons: reverseButtons,
    }).then((result) => {
      if (result.value) {
        onConfirm();
      }
    });
  };

  showCleanModal = (id) =>
    this.showConfirmModal({
      title: "Are you sure to clean pdfs?",
      text: "This action will delete all generated pdfs from system.",
      confirmButtonText: "Clean",
      onConfirm: () => this.actionHandler("clean", id),
    });

  showDeleteModal = (id) =>
    this.showConfirmModal({
      title: "Are you sure to delete tickets?",
      text: "This action will delete all generated tickets (including pdfs) from system.",
      confirmButtonText: "Delete",
      onConfirm: () => this.actionHandler("delete", id),
    });

  renderActionCell = ({ original: rowData }) => {
    if (rowData.changesRequested && !rowData.originalOrderId) return null;

    const deleteButton = (
      <button
        className="btn-red"
        title="Delete"
        onClick={() => this.showDeleteModal(rowData.id)}
      >
        <Icon name={"trash"} />
      </button>
    );

    const cleanButton = (
      <button
        className="btn-red"
        title="Delete"
        onClick={() => this.showCleanModal(rowData.id)}
      >
        Clean
      </button>
    );

    const stopButton = (
      <button
        className="btn-primary"
        title="Stop"
        onClick={() => this.actionHandler("stop", rowData.id)}
      >
        Stop
      </button>
    );

    const startButton = (
      <button
        className="btn-primary"
        title="Start"
        onClick={() => this.actionHandler("start", rowData.id)}
      >
        Start
      </button>
    );

    const loadResult = (
      <button
        className="btn-primary"
        title="Load Result"
        onClick={() => this.loadResult(rowData.id, rowData.resultTag)}
      >
        Load Result
      </button>
    );

    switch (rowData.jobStatus) {
      case "NotCalled":
        return (
          <>
            {startButton}
            {cleanButton}
            {deleteButton}
          </>
        );
      case "Running":
        return <>{stopButton}</>;
      case "Completed":
        return (
          <>
            {loadResult}
            {cleanButton}
            {deleteButton}
          </>
        );
      case "Error":
        return (
          <>
            {startButton}
            {cleanButton}
            {deleteButton}
          </>
        );
      default:
        break;
    }
  };

  render() {
    if (!this.state.isFound) {
      return <Page404 />;
    }

    if (this.state.loading) {
      return <NewLoader isFullScreen />;
    }

    const { currentEvent, currentTicket, actionsList, loading } = this.props;

    const columns = [
      {
        Header: "Title",
        accessor: "resultTag",
      },
      {
        Header: "Generated Ticket Count",
        accessor: "generatedTicketCount",
      },
      {
        Header: "Source File Name",
        accessor: "sourceFileName",
      },
      {
        Header: "Action",
        accessor: "action",
        width: 235,
        className: "generate-pdfs__action",
        Cell: this.renderActionCell,
      },
    ];

    const fullPath = [
      {
        path: ROUTES.EVENTS,
        name: "Events",
      },
      {
        path: ROUTES.NEW_EVENT.replace(":id", currentEvent.id),
        name: currentEvent.name,
      },
      {
        path: ROUTES.TICKET_DETAIL.replace(
          ":event_id",
          currentEvent.id
        ).replace(":id", currentTicket.id),
        name: currentTicket.ticketName,
      },
      {
        name: "Generate Pdfs",
      },
    ];

    const { SERVER_URL } = getCustomURLs();

    return (
      <Container className="ticket-action generate-pdfs">
        <PageTitle>
          <Breadcrumbs routes={fullPath} />
        </PageTitle>

        <input
          placeholder="Title"
          value={this.state.generationTitle}
          onChange={(e) => this.handleChange("generationTitle", e.target.value)}
        />

        <div className="ticket-action__upload">
          <div className="ticket-action__download">
            <form
              action={
                SERVER_URL+ "/Files/Static/csv/SponsorshipTickets.csv"
              }
              method="GET"
            >
              <button>Download template</button>
            </form>
          </div>

          <div className="ticket-action__choose-file">
            <p>Choose the file ( .csv)</p>

            <Upload onButtonEnable={this.onButtonEnable} />
          </div>
        </div>
        <button
          type="button"
          disabled={this.checkIsDisabled()}
          onClick={this.handleSubmit}
          className="ticket-action__submit ticket-action__submit btn-primary"
        >
          Send
        </button>

        {actionsList.length ? (
          loading ? (
            <NewLoader />
          ) : (
            <ReactTable
              resizable={false}
              showPagination={false}
              sortable={false}
              data={actionsList}
              columns={columns}
              defaultPageSize={actionsList.length}
            />
          )
        ) : null}
      </Container>
    );
  }
}

const mapStateToProps = ({
  auth: { user },
  events: { currentEvent, currentTicket },
  ticketGeneration: { actionsList, error, loading },
}) => ({ user, currentEvent, currentTicket, actionsList, error, loading });

const mapDispatchToProps = (dispatch) => ({
  getActions: (token, ticketTemplateId, shouldStartLoading) =>
    dispatch(getActions(token, ticketTemplateId, shouldStartLoading)),
  actionHandler: (userToken, generationActionId, type) =>
    dispatch(actionHandler(userToken, generationActionId, type)),
  getEvent: (eventId, token, action) => dispatch(getEvent(eventId, token, action)),
  getTicket: (data, token) => dispatch(getTicket(data, token)),
  clearCurrentEvent: () => dispatch(clearCurrentEvent()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GeneratePdfs)
);
